import { onError } from 'apollo-link-error';
import { captureMessageInSentry } from 'lib/captureInSentry';
import { Operation } from 'apollo-boost';
import { GraphQLError, DefinitionNode, OperationDefinitionNode } from 'graphql';
import { qffAuthInit } from 'lib/qffAuth';

export const errorLink = onError(({ graphQLErrors, forward, operation }) => {
  graphQLErrors?.forEach((graphQLError) => {
    captureGraphQLError(operation, graphQLError);
  });

  if (includesUnauthenticatedError(graphQLErrors)) {
    qffAuthInit();
  }

  if (includesDownstreamServerError(graphQLErrors)) {
    // Retry operation if it's a downstream error
    return forward(operation);
  }
});

function captureGraphQLError(operation: Operation, graphQLError: GraphQLError) {
  // Note: graphQLError is an object, not an instance of Error. Therefore we need to use capture message instead of capture error
  captureMessageInSentry(`${getOperationType(operation)} ${operation.operationName} failed: ${graphQLError.message}`, graphQLError);
}

function includesUnauthenticatedError(graphQLErrors: readonly GraphQLError[] | undefined): graphQLErrors is GraphQLError[] {
  return graphQLErrors?.some((graphQLError) => graphQLError.extensions?.code === 'UNAUTHENTICATED') ?? false;
}

function includesDownstreamServerError(graphQLErrors: readonly GraphQLError[] | undefined): graphQLErrors is GraphQLError[] {
  return graphQLErrors?.some((graphQLError) => graphQLError.extensions?.code === 'INTERNAL_SERVER_ERROR') ?? false;
}

function isOperationDefinitionNode(node: DefinitionNode): node is OperationDefinitionNode {
  return node.kind === 'OperationDefinition';
}

function getOperationType(operation: Operation) {
  return operation.query.definitions.find(isOperationDefinitionNode)?.operation;
}
